import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
  getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ConditionSerializer21tf3x2n3amih as ConditionSerializer } from './ConditionSerialization.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Never_getInstance32s86skpi7zck as Never_getInstance } from './Condition.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  Mask3fc1c3tjgnucb as Mask,
  $serializernhzjle7ewkqe as $serializer,
} from './Mask.mjs';
import {
  UpdateRestrictions6ebv9x6ps9p5 as UpdateRestrictions,
  $serializerxnzp9a2xfffv as $serializer_0,
} from './UpdateRestrictions.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { LongSerializer_getInstance194e4t3ow5wjs as LongSerializer_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.ModelPermissions', null, 7);
        tmp0_serialDesc.c1b('create', true);
        tmp0_serialDesc.c1b('read', true);
        tmp0_serialDesc.c1b('readMask', true);
        tmp0_serialDesc.c1b('update', true);
        tmp0_serialDesc.c1b('updateRestrictions', true);
        tmp0_serialDesc.c1b('delete', true);
        tmp0_serialDesc.c1b('maxQueryTimeMs', true);
        this.r2j_1 = tmp0_serialDesc;
      }
      s2j(typeSerial0) {
        return $serializer_1().h41(typeSerial0);
      }
      h1c(typeParamsSerializers) {
        return this.s2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer_1() {
  if ($serializerClass === VOID) {
    class $ {
      static i41() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.ModelPermissions', $this, 7);
        tmp0_serialDesc.c1b('create', true);
        tmp0_serialDesc.c1b('read', true);
        tmp0_serialDesc.c1b('readMask', true);
        tmp0_serialDesc.c1b('update', true);
        tmp0_serialDesc.c1b('updateRestrictions', true);
        tmp0_serialDesc.c1b('delete', true);
        tmp0_serialDesc.c1b('maxQueryTimeMs', true);
        $this.f41_1 = tmp0_serialDesc;
        return $this;
      }
      j41(encoder, value) {
        var tmp0_desc = this.f41_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.z2j_1.equals(Never_getInstance())) {
          tmp1_output.c15(tmp0_desc, 0, new (ConditionSerializer())(this.g41_1), value.z2j_1);
        }
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !value.a2k_1.equals(Never_getInstance())) {
          tmp1_output.c15(tmp0_desc, 1, new (ConditionSerializer())(this.g41_1), value.a2k_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 2)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp = !value.b2k_1.equals(new (Mask())(tmp$ret$0));
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 2, $serializer().t40(this.g41_1), value.b2k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !value.c2k_1.equals(Never_getInstance())) {
          tmp1_output.c15(tmp0_desc, 3, new (ConditionSerializer())(this.g41_1), value.c2k_1);
        }
        var tmp_0;
        if (tmp1_output.h15(tmp0_desc, 4)) {
          tmp_0 = true;
        } else {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$1 = emptyList();
          tmp_0 = !value.d2k_1.equals(new (UpdateRestrictions())(tmp$ret$1));
        }
        if (tmp_0) {
          tmp1_output.c15(tmp0_desc, 4, $serializer_0().m41(this.g41_1), value.d2k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !value.e2k_1.equals(Never_getInstance())) {
          tmp1_output.c15(tmp0_desc, 5, new (ConditionSerializer())(this.g41_1), value.e2k_1);
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.f2k_1 === 1000n)) {
          tmp1_output.w14(tmp0_desc, 6, value.f2k_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.j41(encoder, value instanceof ModelPermissions() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.f41_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = 0n;
        var tmp11_input = decoder.l13(tmp0_desc);
        if (tmp11_input.a14()) {
          tmp4_local0 = tmp11_input.x13(tmp0_desc, 0, new (ConditionSerializer())(this.g41_1), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp11_input.x13(tmp0_desc, 1, new (ConditionSerializer())(this.g41_1), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp11_input.x13(tmp0_desc, 2, $serializer().t40(this.g41_1), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.x13(tmp0_desc, 3, new (ConditionSerializer())(this.g41_1), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.x13(tmp0_desc, 4, $serializer_0().m41(this.g41_1), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp11_input.x13(tmp0_desc, 5, new (ConditionSerializer())(this.g41_1), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.r13(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp11_input.x13(tmp0_desc, 0, new (ConditionSerializer())(this.g41_1), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp11_input.x13(tmp0_desc, 1, new (ConditionSerializer())(this.g41_1), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp11_input.x13(tmp0_desc, 2, $serializer().t40(this.g41_1), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.x13(tmp0_desc, 3, new (ConditionSerializer())(this.g41_1), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.x13(tmp0_desc, 4, $serializer_0().m41(this.g41_1), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp11_input.x13(tmp0_desc, 5, new (ConditionSerializer())(this.g41_1), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.r13(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp11_input.m13(tmp0_desc);
        return ModelPermissions().n41(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      az() {
        return this.f41_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [new (ConditionSerializer())(this.g41_1), new (ConditionSerializer())(this.g41_1), $serializer().t40(this.g41_1), new (ConditionSerializer())(this.g41_1), $serializer_0().m41(this.g41_1), new (ConditionSerializer())(this.g41_1), LongSerializer_getInstance()];
      }
      u1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.g41_1];
      }
      static h41(typeSerial0) {
        var $this = this.i41();
        $this.g41_1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var ModelPermissionsClass;
function ModelPermissions() {
  if (ModelPermissionsClass === VOID) {
    class $ {
      constructor(create, read, readMask, update, updateRestrictions, delete_0, maxQueryTimeMs) {
        Companion_getInstance();
        create = create === VOID ? Never_getInstance() : create;
        read = read === VOID ? Never_getInstance() : read;
        var tmp;
        if (readMask === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp = new (Mask())(tmp$ret$0);
        } else {
          tmp = readMask;
        }
        readMask = tmp;
        update = update === VOID ? Never_getInstance() : update;
        var tmp_0;
        if (updateRestrictions === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0_0 = emptyList();
          tmp_0 = new (UpdateRestrictions())(tmp$ret$0_0);
        } else {
          tmp_0 = updateRestrictions;
        }
        updateRestrictions = tmp_0;
        delete_0 = delete_0 === VOID ? Never_getInstance() : delete_0;
        maxQueryTimeMs = maxQueryTimeMs === VOID ? 1000n : maxQueryTimeMs;
        this.z2j_1 = create;
        this.a2k_1 = read;
        this.b2k_1 = readMask;
        this.c2k_1 = update;
        this.d2k_1 = updateRestrictions;
        this.e2k_1 = delete_0;
        this.f2k_1 = maxQueryTimeMs;
      }
      o41(create, read, readMask, update, updateRestrictions, delete_0, maxQueryTimeMs) {
        return new (ModelPermissions())(create, read, readMask, update, updateRestrictions, delete_0, maxQueryTimeMs);
      }
      h2k(create, read, readMask, update, updateRestrictions, delete_0, maxQueryTimeMs, $super) {
        create = create === VOID ? this.z2j_1 : create;
        read = read === VOID ? this.a2k_1 : read;
        readMask = readMask === VOID ? this.b2k_1 : readMask;
        update = update === VOID ? this.c2k_1 : update;
        updateRestrictions = updateRestrictions === VOID ? this.d2k_1 : updateRestrictions;
        delete_0 = delete_0 === VOID ? this.e2k_1 : delete_0;
        maxQueryTimeMs = maxQueryTimeMs === VOID ? this.f2k_1 : maxQueryTimeMs;
        return $super === VOID ? this.o41(create, read, readMask, update, updateRestrictions, delete_0, maxQueryTimeMs) : $super.o41.call(this, create, read, readMask, update, updateRestrictions, delete_0, maxQueryTimeMs);
      }
      toString() {
        return 'ModelPermissions(create=' + toString(this.z2j_1) + ', read=' + toString(this.a2k_1) + ', readMask=' + this.b2k_1.toString() + ', update=' + toString(this.c2k_1) + ', updateRestrictions=' + this.d2k_1.toString() + ', delete=' + toString(this.e2k_1) + ', maxQueryTimeMs=' + this.f2k_1.toString() + ')';
      }
      hashCode() {
        var result = this.z2j_1.hashCode();
        result = imul(result, 31) + this.a2k_1.hashCode() | 0;
        result = imul(result, 31) + this.b2k_1.hashCode() | 0;
        result = imul(result, 31) + this.c2k_1.hashCode() | 0;
        result = imul(result, 31) + this.d2k_1.hashCode() | 0;
        result = imul(result, 31) + this.e2k_1.hashCode() | 0;
        result = imul(result, 31) + getBigIntHashCode(this.f2k_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ModelPermissions()))
          return false;
        if (!this.z2j_1.equals(other.z2j_1))
          return false;
        if (!this.a2k_1.equals(other.a2k_1))
          return false;
        if (!this.b2k_1.equals(other.b2k_1))
          return false;
        if (!this.c2k_1.equals(other.c2k_1))
          return false;
        if (!this.d2k_1.equals(other.d2k_1))
          return false;
        if (!this.e2k_1.equals(other.e2k_1))
          return false;
        if (!(this.f2k_1 === other.f2k_1))
          return false;
        return true;
      }
      static n41(seen0, create, read, readMask, update, updateRestrictions, delete_0, maxQueryTimeMs, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, Companion_getInstance().r2j_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.z2j_1 = Never_getInstance();
        else
          $this.z2j_1 = create;
        if (0 === (seen0 & 2))
          $this.a2k_1 = Never_getInstance();
        else
          $this.a2k_1 = read;
        if (0 === (seen0 & 4)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp.b2k_1 = new (Mask())(tmp$ret$0);
        } else
          $this.b2k_1 = readMask;
        if (0 === (seen0 & 8))
          $this.c2k_1 = Never_getInstance();
        else
          $this.c2k_1 = update;
        if (0 === (seen0 & 16)) {
          var tmp_0 = $this;
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$1 = emptyList();
          tmp_0.d2k_1 = new (UpdateRestrictions())(tmp$ret$1);
        } else
          $this.d2k_1 = updateRestrictions;
        if (0 === (seen0 & 32))
          $this.e2k_1 = Never_getInstance();
        else
          $this.e2k_1 = delete_0;
        if (0 === (seen0 & 64))
          $this.f2k_1 = 1000n;
        else
          $this.f2k_1 = maxQueryTimeMs;
        return $this;
      }
    }
    initMetadataForClass($, 'ModelPermissions', ModelPermissions, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    ModelPermissionsClass = $;
  }
  return ModelPermissionsClass;
}
//region block: exports
export {
  ModelPermissions as ModelPermissions2241fbc4jxkyq,
  Companion_getInstance as Companion_getInstance23ulzawec7mjy,
};
//endregion

//# sourceMappingURL=ModelPermissions.mjs.map
